import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Star } from "lucide-react";

export const ReviewsSection = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    api.get("/reviews/public").then((r) => setReviews(r.data)).catch(() => {});
  }, []);

  if (reviews.length === 0) return null;

  return (
    <section className="py-20 border-t border-sky-500/10">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="max-w-2xl mb-12">
          <div className="text-xs font-mono uppercase tracking-widest text-sky-400 mb-3">Depoimentos</div>
          <h2 className="text-3xl sm:text-4xl font-bold">O que nossos clientes dizem</h2>
        </div>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-testid="reviews-grid">
          {reviews.map((r) => (
            <Card key={r.review_id} className="bg-slate-900/50 border-slate-800 hover:border-sky-500/40 transition-all">
              <CardContent className="p-6">
                <div className="flex gap-0.5 mb-3">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <Star key={i} className={`w-4 h-4 ${i < r.rating ? "text-yellow-400 fill-yellow-400" : "text-slate-700"}`} />
                  ))}
                </div>
                <p className="text-slate-300 text-sm leading-relaxed mb-4">"{r.comment}"</p>
                <div className="text-xs font-mono uppercase tracking-wider text-sky-400">— {r.customer_name}</div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
